import { CharField, ImageField, MultiSelectField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Collection } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"
import { COLLECTION_TYPES, EVENT_TYPES } from "../../constants"

export default function CollectionForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Collection>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <SingleSelectField
        label="Categoria"
        layout="horizontal"
        options={COLLECTION_TYPES}
        value={COLLECTION_TYPES.find((option) => option.value === values.category) || null}
        onChange={(value) => {
          setFieldValue("category", value?.value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "category") : undefined}
        errorMessage={getIn(errors, "category")}
        required
      />
      <MultiSelectField
        label="Tipi di evento"
        layout="horizontal"
        options={EVENT_TYPES}
        value={EVENT_TYPES.filter((type) => values.event_types?.includes(type.value))}
        onChange={(value) => {
          setFieldValue(
            "event_types",
            value.map((v) => v.value),
          )
        }}
        isValid={submitCount > 0 ? !getIn(errors, "event_types") : undefined}
        errorMessage={getIn(errors, "event_types")}
        required
      />
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.description || ""}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "description") : undefined}
        errorMessage={getIn(errors, "description")}
      />
      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.image || ""}
        onChange={(value) => {
          setFieldValue("image", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "image") : undefined}
        errorMessage={getIn(errors, "image")}
      />
    </Col>
  )
}
